"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBankingDay = void 0;
const bankingHolidays_1 = require("../../constants/bankingHolidays");
const isWeekday_1 = require("../../utils/isWeekday");
const toIsoDate_1 = require("../../utils/toIsoDate");
function isBankingDay(date) {
    const isoDate = (0, toIsoDate_1.toIsoDate)(date);
    return !(isoDate === null) && (0, isWeekday_1.isWeekday)(isoDate) && !bankingHolidays_1.bankingHolidays.includes(isoDate);
}
exports.isBankingDay = isBankingDay;
//# sourceMappingURL=index.js.map